/**
 * Gravatar URL from email address.
 * Uses MD5 hash; d=identicon gives a default geometric image when no Gravatar is set.
 */

import md5 from "md5";

const GRAVATAR_BASE = "https://www.gravatar.com/avatar";

/**
 * Returns the Gravatar image URL for an email address.
 * @param email - Email address (will be trimmed and lowercased)
 * @param size - Optional size in pixels (default 80)
 * @param defaultType - Optional default image type when no Gravatar (default "identicon")
 */
export function gravatarUrl(
  email: string,
  size: number = 80,
  defaultType: string = "identicon"
): string {
  const normalized = (email || "").trim().toLowerCase();
  if (!normalized) {
    return `${GRAVATAR_BASE}/?s=${size}&d=${defaultType}`;
  }
  const hash = md5(normalized);
  return `${GRAVATAR_BASE}/${hash}?s=${size}&d=${defaultType}`;
}
